import React, { useCallback, useEffect } from "react";
import { useAppDispatch } from "../../redux/configureStore";
import { BsChatDots } from "react-icons/bs";
import breakPoints from "./BreakPoints";
import { setRightMenu, toggleRightMenu } from "./uiSlice";
import useLayout from "./useLayout";
import { useTenant } from "../api/helpers";

const MobileChatButton = () => {
  const dispatch = useAppDispatch();
  const tenant = useTenant();

  const { isMediumOrSmaller } = useLayout();

  const toggleMenu = useCallback(() => {
    dispatch(toggleRightMenu());
  }, [dispatch]);

  useEffect(() => {
    if (isMediumOrSmaller) {
      dispatch(setRightMenu(false));
    }
  }, [dispatch, isMediumOrSmaller]);

  return (
    <button onClick={toggleMenu} type="button">
      <BsChatDots size={30} color="white" />
      <style jsx>{`
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          position: fixed;
          bottom: 15px;
          right: 15px;
          z-index: 3;
          border-radius: 50%;
          background: ${tenant?.color ?? "green"};
          border: medium none;
        }

        div:hover {
          cursor: pointer;
        }
        @media only screen and (min-width: ${breakPoints.medium}px) {
          button {
            display: none;
          }
        }
      `}</style>
    </button>
  );
};

export default MobileChatButton;
